import * as React from 'react'

import { Input } from '@metrisk/react_metrisk-components'

// Styles
import './PasswordInput.scss'
import PasswordStrengthMeter from './PasswordStrengthMeter'

const PasswordInput = ({ value, strengthMeter, onChange }: PasswordInput.IProps) => {
  return (
    <>
      <Input className="password-input" value={value} type={'password'} onChange={onChange} />
      {strengthMeter && <PasswordStrengthMeter value={value} />}
    </>
  )
}

export default PasswordInput
